import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useTotemSectorActions } from '../hooks';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useCallCustomer } from '../hooks/Inbox/useCallCustomer';

interface CallButtonProps {
  buttonVariant?: GlobalButtonVariant;
  sectorId?: string;
  trackNumber?: string;
  onBeforeCall?: () => Promise<boolean | void>;
}

const CallButton = ({
  buttonVariant = GlobalButtonVariant.primaryButton,
  sectorId,
  trackNumber,
  onBeforeCall,
}: CallButtonProps) => {
  const { onCall, isLoadingCall } = useTotemSectorActions();

  const { onCallCustomer } = useCallCustomer({
    sectorId,
    trackNumber,
    onBeforeCall,
    onCall,
  });

  return (
    <GlobalButton
      variant={buttonVariant}
      action={onCallCustomer}
      disabled={isLoadingCall}
    >
      <NotificationsIcon />
      {' Llamar'}
    </GlobalButton>
  );
};

export default CallButton;
